import React from 'react';
import { getTotalBemClass } from 'components/scores';

const CustomEventLeaderboardScoreToParColumn = ({ playerScoreToPar }) => {
    const toParClass = getTotalBemClass(playerScoreToPar);
    const scoreToPar = (playerScoreToPar === null || playerScoreToPar === undefined || playerScoreToPar === '') ? '-' : playerScoreToPar;

    return (
        <div className="custom-event-leaderboard__cell custom-event-leaderboard__cell--hole">
            <div className="custom-event-leaderboard__label">
                PAR
            </div>
            <div className={`score-cell score-cell--${toParClass} score-cell--has-border`}>
                {scoreToPar}
            </div>
        </div>
    );
};

export default CustomEventLeaderboardScoreToParColumn;
